import { useEffect, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  Button,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { gpColors } from "../../../constants/colors";
import { getCookie } from "../../../Functions";
import CryptoAES from "crypto-js/aes";
import CryptoENC from "crypto-js/enc-utf8";
import SideDrawer from "../Drawer";
import AddProductValMOdal from "../AddProductValMOdal";
import Cookies from "js-cookie";
import api from "../../Interceptors/axiosInstance";
import { CustomLoader } from "../../Common/CustomLoader"
const useStyles = makeStyles((theme) => ({
  roots: {
    display: "flex",
    height: "auto",
    backgroundColor: "#EAE4E8",
  },
  content: {
    flexGrow: 1,
    paddingTop: "84px",
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    height: "100vh",
  },
  title: {
    fontSize: "20px",
    fontWeight: 600,
    paddingBottom: 20,
  },
  root: {
    padding: "30px",
    minHeight: "280px",
    marginTop: "20px",
  },
  fieldBox: {
    width: "45%",
    [theme.breakpoints.only("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.only("sm")]: {
      width: "100%",
    },
  },
  subBtnsBox: {
    display: "flex",
    flexDirection: "row",
    gap: 9,
  },
  submitButton: {
    // textTransform: "none",
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    marginTop: "20px",
    width: "20%",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
  },
  exportButton: {
    backgroundColor: gpColors.logoBrown,
    color: "#fff",
    marginBottom: "12px",
    marginTop: "20px",
    width: "auto",
    "&.MuiButtonBase-root": {
      "&:hover": { backgroundColor: gpColors.logoBrown },
    },
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
  },
}));

const ImportUpcAndCbm = () => {
  const classes = useStyles();
  const [userData, setUserData] = useState({});
  const [file, setFile] = useState(null);
  const [loader, setLoader] = useState(false);
  const [alert, setAlert] = useState({
    alertStatus: false,
    alertMessage: "",
    alertColor: "",
  });

  const [validationModal, setValidationModal] = useState(false);
  function closeValidationModal() {
    setValidationModal(false);
  }

  // Alert box close
  const handleAlertClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({
      ...alert,
      alertStatus: false,
      alertColor: "",
      alertMessage: "",
    });
  };

  // Getting cookies
  // const getLoginInfoData = () => {
  //     const getValue = getCookie("guardPlus_user");
  //     if (getValue !== null) {
  //         const decryptedValue = CryptoAES.decrypt(getValue, "secretKey");
  //         const userVal = JSON.parse(decryptedValue.toString(CryptoENC));
  //         setUserData(userVal);
  //     }
  // };

  // const sessionUsername = Cookies.get("userName");
      const sessionUsername = sessionStorage.getItem("userName");

  const getLoginInfoData = () => {
    setUserData({ username: sessionUsername });
  };
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    getLoginInfoData();
  }, []);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      setLoader(true);
      try {
        // const response = await fetch(`${process.env.REACT_APP_API_ENDPOINT}/uploadFile`, {
        //     method: "POST",
        //     body: formData,
        //     headers: {
        //         // "ngrok-skip-browser-warning": "true",
        //         Authorization: `Token ${userData.loginInfo.data.jwt}`,
        //     },
        // });
        const response = await api.post("/uploadFile", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        const result = await response.data;
        if (result.result === "Success") {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "green",
            alertMessage: "File uploaded successfully",
          });
        } else if (
          result.message === "Cannot get a STRING value from a NUMERIC cell"
        ) {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "Failed to upload file. Please select a valid file.",
          });
        } else {
          setAlert({
            ...alert,
            alertStatus: true,
            alertColor: "red",
            alertMessage: "Failed to upload file. Please try again.",
          });
        }
        setLoader(false);
        setFile("");
      } catch (error) {
        console.error("Error uploading file:", error);
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "Error uploading file. Please try after sometime.",
        });
        setLoader(false);
      }
    } else {
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "Please choose a file",
      });
    }
  };

  const handleExport = async () => {
    console.log("handle");
    setLoader(true);
    try {
      const response = await api.get("export-part-upc-cbm-mapper-data", {
        responseType: "blob",
      });

      if (response && response.status === 200) {
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const dateOnly = new Date().toISOString().split("T")[0];
        a.download = `UPC_CBM_Data_${dateOnly}.xlsx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();

        window.URL.revokeObjectURL(url);
      } else if (response.status === 404) {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "No data found to generate Excel file.",
        });
      } else {
        setAlert({
          ...alert,
          alertStatus: true,
          alertColor: "red",
          alertMessage: "An error occurred while exporting the data.",
        });
      }
    } catch (error) {
      console.error("Error exporting containers:", error);
      setAlert({
        ...alert,
        alertStatus: true,
        alertColor: "red",
        alertMessage: "An error occurred while exporting the data.",
      });
    } finally {
      setLoader(false);
    }
  };
  return (
    <Box className={classes.roots}>
      <SideDrawer tabName="importUpcCbm" userData={userData} />
      <main className={classes.content}>
        <Typography className={classes.title}>Import UPC And CBM</Typography>
        <Divider />
        <Card className={classes.root}>
          <CardContent>
            <Box display="flex" flexWrap="wrap" alignItems="left">
              <TextField
                type="file"
                variant="outlined"
                onChange={handleFileChange}
                className={classes.fieldBox}
                inputProps={{ accept: ".xls,.xlsx" }}
              />
            </Box>
            <Box className={classes.subBtnsBox}>
              <Button
                variant="contained"
                className={classes.submitButton}
                onClick={handleUpload}
              >
                Upload File
                {/* {loader ? <CircularProgress size={25} /> : "Upload File"} */}
              </Button>
              <Button
                variant="contained"
                className={classes.exportButton}
                onClick={handleExport}
              >
                Download Complete Data
                {/* {downloadBtnloader ? <CircularProgress size={25} /> : " Download Complete Data"} */}
              </Button>
            </Box>
          </CardContent>
        </Card>
      </main>
      <AddProductValMOdal
        validationModal={validationModal}
        closeValidationModal={closeValidationModal}
        handleAlertClose={handleAlertClose}
        alert={alert}
      />
      <CustomLoader loading={loader} />
    </Box>
  );
};

export default ImportUpcAndCbm;
